import classNames from "classnames";
import classes from "./FCCTag.module.less";
import { IconType } from "~/common/components/icon/IconType";
import { Icon } from "~/common/components/icon/Icon";

interface Props {
  className?: string;
  anchor?: "left" | "right" | "top" | "bottom";
}

export const FCCTag = (props: Props) => {
  return (
    <div className={classNames(classes.root, props.className, props.anchor && classes[props.anchor])}>
      <span>Free Capacity</span>
      <Icon type={IconType.BallBearing} />
    </div>
  );
};
